export default "__VITE_ASSET__BPZ$$_TS__"